<app-page-header
  title="Home"
  titleLink="/reports"
  active_item="Credenciais API"
>
</app-page-header>
<form>
  <div class="row">
    <h5>{{ "common.apiCredentials" | translate }}</h5>
    <div class="col-md-12 col-xl-12">
      <div
        class="card sales-summary shadow"
        [ngClass]="{
          'rounded-10': !isFilterColapsed,
          'rounded-10-top': isFilterColapsed
        }"
      ></div>
    </div>
    <div class="loading-extrato" *ngIf="!isLoaded">
      <div class="dimmer active">
        <div class="lds-ring">
          <div></div>
        </div>
      </div>
    </div>
    <div class="col-md-12 col-xl-12">
      <div
        class="card sales-summary shadow"
        [ngClass]="{
          'rounded-10': !isFilterColapsed,
          'rounded-10-top': isFilterColapsed
        }"
      >
        <div class="card-header">
          <div class="card-title mb-0">
            {{ "common.operatingAccount" | translate }}
          </div>
          <div class="card-options">
            <a
              href="javascript:void(0)"
              class="card-options-collapse"
              data-bs-toggle="card-collapse"
              [attr.aria-expanded]="!isFilterColapsed"
              ><i
                class="fe fe-chevron-{{ !isFilterColapsed ? 'up' : 'down' }}"
              ></i
            ></a>
          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-xl-4 col-lg-6 col-sm-6">
              <div class="form-group">
                <label class="form-label">{{
                  "common.accountId" | translate
                }}</label>
                <input
                  class="form-control"
                  [value]="accountOrigin?.accountId || ''"
                  disabled
                />
              </div>
            </div>

            <div class="col-xl-4 col-lg-6 col-sm-6">
              <div class="form-group">
                <label class="form-label">{{
                  "common.accountHolder" | translate
                }}</label>
                <input
                  class="form-control"
                  [value]="accountOrigin?.razaoSocial || ''"
                  disabled
                />
              </div>
            </div>

            <div class="col-xl-4 col-lg-6 col-sm-6">
              <div class="form-group">
                <label class="form-label">{{
                  "common.bank" | translate
                }}</label>
                <input
                  class="form-control"
                  [value]="accountOrigin?.bankName || ''"
                  disabled
                />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-xl-4 col-lg-6 col-sm-6">
              <div class="form-group">
                <label class="form-label">Client</label>
                <div class="input-icon-container">
                  <input
                    class="form-control"
                    [value]="accountOrigin?.clientId || ''"
                    readonly
                  />
                  <i
                    class="fe fe-copy input-icon"
                    (click)="
                      copyToClipboard(accountOrigin?.accountId, 'Client')
                    "
                  ></i>
                </div>
              </div>
            </div>

            <div class="col-xl-4 col-lg-6 col-sm-6">
              <div class="form-group">
                <label class="form-label">Secret</label>
                <div class="input-icon-container">
                  <input
                    class="form-control"
                    [value]="accountOrigin?.secretId || ''"
                    readonly
                  />
                  <i
                    class="fe fe-copy input-icon"
                    (click)="
                      copyToClipboard(accountOrigin?.accountId, 'Secret')
                    "
                  ></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="card sales-summary rounded-10 shadow">
        <div class="card-header">
          <div class="card-title mb-0">{{ "common.accounts" | translate }}</div>
        </div>
        <div class="card-body button-table">
          <app-table-api-credentials
            (loading)="onTableLoading($event)"
            (switched)="onTableSwitched()"
          ></app-table-api-credentials>
        </div>
      </div>
    </div>
  </div>
</form>
